import { render, staticRenderFns } from "./editFromInfo.vue?vue&type=template&id=361ab146&"
import script from "./editFromInfo.vue?vue&type=script&lang=js&"
export * from "./editFromInfo.vue?vue&type=script&lang=js&"
import style0 from "./editFromInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports